import { FormGroup, MenuItem } from '@mui/material';
import CustomSelectValidator from 'common/components/CustomSelectValidators';
import { useTranslation } from 'react-i18next';

const EventFormActorRoleSelector = ({ actors, role, handleRoleChange, onLimit }) => {
    const { t } = useTranslation();

    const isValidRole = () => {
        return (role === 'guest' && !onLimit) || (role === 'host' && !actors?.find((actor) => actor.role === 'host'));
    };

    return (
        <FormGroup>
            <CustomSelectValidator
                name="role"
                select
                size="small"
                fullWidth={true}
                value={isValidRole() ? role : ''}
                onChange={handleRoleChange}
                variant="outlined"
                disabled={!actors}
                validators={['required']}
                errorMessages={[t('app.common.required')]}
            >
                {!actors?.find((actor) => actor.role === 'host') && (
                    <MenuItem key="host" value="host">
                        {t('event.eventFormActorRoleSelector.asHost')}
                    </MenuItem>
                )}
                {!onLimit && (
                    <MenuItem key="guest" value="guest">
                        {t('event.eventFormActorRoleSelector.asGuest')}
                    </MenuItem>
                )}
            </CustomSelectValidator>
        </FormGroup>
    );
};

export default EventFormActorRoleSelector;
